import React from 'react';
import { PageHeading } from '../../shared';
export var LendingCriteriaPage = function () { return (React.createElement("section", null,
    React.createElement(PageHeading, { headingLevel: 2, title: "Lending Criteria", icon: "lendingcriteria", mb: 6 }))); };
